import styled from 'styled-components'

import { Button } from '@sketch/components'
import { ReactComponent as DotsSVG } from '@sketch/icons/dots-3-horizontal-24-svg'

export const SettingsButton = styled(Button).attrs({ size: '32' })`
  padding: 4px 8px;
  box-shadow: none;
  border: none;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};

  :hover {
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
    background-color: ${({ theme }) => theme.colors.state.hover};
  }

  :focus,
  :active {
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
  }
`

export const DotsIcon = styled(DotsSVG)`
  width: 24px;
  height: 24px;
`
